import { createSlice } from "@reduxjs/toolkit";
import { authApi } from "./auth.api";
import { getRoleName } from "../../shared/utils/roleMapping";

const ALLOWED_ROLES = Object.freeze([
  "Super Admin",
  "MIS Team Admin",
  "General Manager",
  "Senior Manager",
  "Manager",
  "Execution Rep",
  "School Admin",
]);

export const USER_TYPES = Object.freeze({
  SCHOOL: "school",
  SUPERADMIN: "super_admin",
});

const initialState = {
  user: null,
  tokens: null,
  mdm: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    userLogout(state) {
      state.user = initialState.user;
      state.tokens = initialState.tokens;
      state.mdm = initialState.mdm;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        authApi.endpoints.superAdminLogin.matchFulfilled,
        (state, { payload, meta }) => {
          if (payload) {
            const userRoleId = payload.roles?.[0];
            const userRoleName = getRoleName(userRoleId);
            const loginType = meta.arg.originalArgs.body.login_type;

            // Verify role is allowed
            if (userRoleName && ALLOWED_ROLES.includes(userRoleName)) {
              // School Admin can only login with School Admin option
              if (
                userRoleName === "School Admin" &&
                loginType !== USER_TYPES.SCHOOL
              ) {
                return;
              }

              // Non-School Admin users can only login with Infinity Admin option
              if (
                userRoleName !== "School Admin" &&
                loginType === USER_TYPES.SCHOOL
              ) {
                return;
              }

              state.user = {
                first_name: payload.firstName,
                last_name: payload.lastName,
                admission_id: payload.admission_number,
                crnId: payload.crnId,
              };

              state.tokens = {
                access_token: payload.accessToken,
                refresh_token: payload.refreshToken,
              };

              state.mdm = {
                role_ids: payload.roles,
              };
            }
          }
        }
      )
      // Handle verification responses
      .addMatcher(
        authApi.endpoints.verifyToken.matchRejected,
        (state, { error }) => {
          // Check for 401 status and expired token response
          if (
            error?.status === 401 ||
            error?.data?.detail === "Expired Signature"
          ) {
            state.user = initialState.user;
            state.tokens = initialState.tokens;
            state.mdm = initialState.mdm;
          }
        }
      );
  },
});

export const { userLogout } = authSlice.actions;
export default authSlice.reducer;
